module.exports = __webpack_public_path__ + "media/images/icons/icon_mypage_donation_price_primary-5ccd033b0b5751a0bf37f2deca1a8485.svg";